import { useMutation } from '@tanstack/react-query'

import { deleteFreeeEndJournalEntryTransitionMode } from '@src/api'
import { DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDeleteFreeeEndJournalEntryTransitionMode = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiDeleteFreeeEndJournalEntryTransitionModeRequest
    ) => deleteFreeeEndJournalEntryTransitionMode(axiosInstance, params),
  })
}
